export function myGtag() {
	//console.log("gtag called");
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(arguments);
}